import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useLoadActiveData } from "../../hooks/useLoadActiveData";
import { useLocation } from "react-router-dom";
import { parseFilterQuery } from "../utils/parseFilterQuery";

const ObjekteListePrint = () => {
  const { user, fetchWithAuth, accessToken } = useAuth();
  const [objekte, setObjekte] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load metadata (countries, materials, etc.)
  const {
    kategorienAktiv: kategorien,
    ablageorteAktiv: ablageorte,
    typenAktiv: typen,
    laenderAktiv: laender,
    materialienAktiv: materialien,
    waehrungenAktiv: waehrungen,
    zustaendeAktiv: zustaende,
    eigentuemerAktiv: eigentuemer,
    loading: metaLoading,
    error,
  } = useLoadActiveData();

  // Read filters from URL
  const location = useLocation();
  const urlFilters = parseFilterQuery(location.search);

  const currentDate = new Intl.DateTimeFormat("de-DE").format(new Date());

  // Helper functions to resolve names
  const getMaterialName = (id) =>
    materialien.find((m) => m.id === id)?.name || "Unbekannt";

  const getWaehrungName = (id) =>
    waehrungen.find((w) => w.id === id)?.name || "Unbekannt";

  const getLandName = (id) =>
    laender.find((l) => l.id === id)?.name || "Unbekannt";

  const getKategorieName = (id) =>
    kategorien.find((l) => l.id === id)?.name || "Unbekannt";

  useEffect(() => {
    const fetchObjekte = async () => {
      try {
        const params = new URLSearchParams();

        // Apply filters from URL
        const add = (key, value) => {
          if (value !== null && value !== undefined && value !== "") {
            params.append(key, value);
          }
        };

        add("kategorie", urlFilters.kategorie);
        add("ablageort", urlFilters.ablageort);
        add("typ", urlFilters.typ);
        add("land", urlFilters.land);
        add("material", urlFilters.material);
        add("waehrung", urlFilters.waehrung);
        add("zustand", urlFilters.zustand);
        add("eigentuemer", urlFilters.eigentuemer);

        if (urlFilters.jahrgangMin)
          params.append("jahrgang_min", urlFilters.jahrgangMin);
        if (urlFilters.jahrgangMax)
          params.append("jahrgang_max", urlFilters.jahrgangMax);

        // Disable pagination
        params.set("page_size", 99999);

        const response = await fetchWithAuth(`/api/main/?${params}`, {
          headers: { "Content-Type": "application/json" },
        });

        const data = await response.json();
        setObjekte(data.results || []);

        // Trigger print dialog
        setTimeout(() => window.print(), 500);
      } catch (err) {
        console.error("Fehler beim Laden der Objekte:", err);
      } finally {
        setLoading(false);
      }
    };

    // Set document title
    const today = new Date();
    document.title = `Kolektanto_Printliste_${today.getFullYear()}_${String(
      today.getMonth() + 1
    ).padStart(2, "0")}_${String(today.getDate()).padStart(2, "0")}`;

    if (accessToken) fetchObjekte();
  }, [accessToken, location.search]);

  if (loading || metaLoading) return <div>Daten werden geladen…</div>;
  if (error) return <div className="text-danger">Fehler: {error}</div>;

  return (
    <div className="container mt-4" style={{ fontSize: "12px" }}>
      <h2 className="text-center mb-4">Kolektanto – Report Ausdruck</h2>

      <div className="d-flex justify-content-between mb-3">
        <div>
          <strong>Benutzer:</strong> {user?.first_name} {user?.last_name}
        </div>
        <div>
          <strong>Datum:</strong> {currentDate}
        </div>
      </div>

      <table className="table table-bordered table-sm">
        <thead>
          <tr>
            <th>Nr.</th>
            <th>Kategorie</th>
            <th>Wert</th>
            <th>Sammlerwert</th>
            <th>Währung</th>
            <th>Land</th>
            <th>Jahrgang</th>
            <th>Material</th>
            <th>Anzahl</th>
          </tr>
        </thead>
        <tbody>
          {objekte.map((o) => (
            <tr key={o.id}>
              <td>{o.id}</td>
              <td>{getKategorieName(o.kategorie)}</td>
              <td>{o.nominalwert}</td>
              <td>{o.sammlerwert}</td>
              <td>{getWaehrungName(o.waehrung)}</td>
              <td>{getLandName(o.land)}</td>
              <td>{o.jahrgang}</td>
              <td>{getMaterialName(o.material)}</td>
              <td>{o.anzahl}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ObjekteListePrint;
